var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product.video)?_c('div',{staticClass:"product-icon-tooltip"},[_c('div',{staticClass:"prod-icon icon-square d-flex flex-column align-items-center"},[_c('i',{domProps:{"innerHTML":_vm._s(_vm.getIcon[0].svg)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }